// extracted by mini-css-extract-plugin
export default {"bubble":"Explanation_bubble__iVi43","icon":"Explanation_icon__G1Ap6"};